// @flow
import React from 'react'
import styled, { type StyledComponent } from 'styled-components'
import sprite from '../../images/main/checkbox.png'
import classNames from 'classnames'

const spriteWidth = 28
const spriteHeight = 28

const Wrapper: StyledComponent<{ alignBaseline?: boolean }, any, any> = styled.div`
  display: flex;
  align-items: last-baseline;
  cursor: pointer;
  user-select: none;
  ${({ alignBaseline }) => (alignBaseline ? 'align-items: baseline' : '')};
`

const Label: StyledComponent<
  {
    compact?: boolean,
    disabled?: boolean,
    liteDisableMode?: boolean
  },
  any,
  any
> = styled.div`
  font-size: 14px;
  vertical-align: top;
  ${({ liteDisableMode, disabled }) => (liteDisableMode && disabled ? 'color: #888' : '')};
  line-height: ${({ compact }) => (compact ? 16 : 32)}px;
  padding-left: ${({ compact }) => (compact ? 6 : 8)}px;
`

const Picture: StyledComponent<
  {
    compact?: boolean,
    invisible?: boolean,
    disabled?: boolean,
    liteDisableMode?: boolean,
    checked: boolean
  },
  any,
  any
> = styled.div`
  width: ${({ compact }) => (compact ? spriteWidth / 2 : spriteWidth)}px;
  height: ${({ compact }) => (compact ? spriteHeight / 2 : spriteHeight)}px;
  background: url(${sprite}) 0 0 no-repeat;
  background-size: cover;
  ${({ invisible }) => (invisible ? 'opacity: 0' : '')};
  ${({ compact }) => (compact ? 'position: relative' : '')};
  background-position-y: ${({ disabled, liteDisableMode, checked }) => {
    if (checked) {
      if (disabled) {
        return liteDisableMode ? `-${spriteHeight}px` : '100%'
      } else {
        return '33.33%'
      }
    } else {
      return disabled && !liteDisableMode ? '66.66%' : '0'
    }
  }};
`

type Props = {|
  className?: string,
  checked: boolean,
  disabled?: boolean,
  compact?: boolean,
  label?: string,
  onChange?: (boolean) => void,
  liteDisableMode?: boolean,
  alignBaseline?: boolean,
  invisible?: boolean
|}

export default function Checkbox(props: Props) {
  return (
    <Wrapper
      alignBaseline={props.alignBaseline}
      className={classNames(props.className, { 't-OrtCheckboxChecked': props.checked })}
      onClick={() => {
        if (props.disabled) return
        props.onChange && props.onChange(!props.checked)
      }}
    >
      <div>
        <Picture
          className="t-OrtCheckboxPicture"
          compact={props.compact}
          invisible={props.invisible}
          checked={props.checked}
          disabled={props.disabled}
          unselectable="on"
        />
      </div>
      {props.label && (
        <Label
          compact={props.compact}
          liteDisableMode={props.liteDisableMode}
          disabled={props.disabled}
          className="t-OrtCheckboxLabel"
        >
          {props.label}
        </Label>
      )}
    </Wrapper>
  )
}
